import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { cloneDeep, sortBy } from 'lodash';
import { dealGet, updateDeal } from './dealSettings.store';
import { ToastError, ToastInfo } from "components/Global/Toasts/Toasty";
import { withRouter } from "react-router";
import { CardPageLayout } from "component-lib/CardPageLayout";
import { GenericHeroCard } from "component-lib/";
import { mapCompanySelector } from "store/state/auth";
import { DEAL_SECTION_KEYS } from "./deal.constants";
import { AccordionEditSection } from "component-lib/AccordionSection";
import { rows as generalInfoRows } from './deal-general-information/section-deal-general-info-edit-rows';
import { rows as dealDisposition, generateCashflowEdit } from './deal-disposition/section-deal-disposition-edit-rows';
import { rows as dealOrganization } from './deal-organization/section-deal-organization-edit-rows';
import {modifyValuesForSerialization} from './deal.helper';
import EditDealIntegrations from "./deal-integrations/editDealIntegrations";

class DealEdit extends React.Component {
  state = {
    isSaving: false,
    isCanceling: false
  };

  componentDidMount() {
    document.getElementById('ScrollToNav').scrollIntoView({ behavior: 'smooth' });
    const { dealId } = this.props.match.params;

    // NOTE: Handles the scenario that the store is not loaded when you come to this page.
    //       ex: refresh page.

    const { deal } = this.props;
    if (!deal) this.props.dealGet({ dealId });
  }

  componentDidUpdate() {
    const { dealId, sectionName } = this.props.match.params;
  }

  deleteFalsyValues = deal => {
    this.deleteIfFalsy(deal, "name");
    this.deleteIfFalsy(deal, "protected");
    this.deleteIfFalsy(deal, "fundId");
    this.deleteIfFalsy(deal, "userId");
    this.deleteIfFalsy(deal, "jvPartner");
    this.deleteIfFalsy(deal, "jvPartnerShare");
    this.deleteIfFalsy(deal, "sponsorOwnershipShare");
    this.deleteIfFalsy(deal, "imageSmall");
    this.deleteIfFalsy(deal, "imageMedium");
    this.deleteIfFalsy(deal, "imageLarge");
    this.deleteIfFalsy(deal, "metrics");
    this.deleteIfFalsy(deal, "overviewData");
    this.deleteIfFalsy(deal, "currentBalance");
    this.deleteIfFalsy(deal, "maturity");
    this.deleteIfFalsy(deal, "rate");
    this.deleteIfFalsy(deal, "monthlyPayment");
    this.deleteIfFalsy(deal, "prepaymentPenalty");
    this.deleteIfFalsy(deal, "recourse");
    this.deleteIfFalsy(deal, "totalOccupancy");
    this.deleteIfFalsy(deal, "totalNOI");
    this.deleteIfFalsy(deal, "dscr");
    this.deleteIfFalsy(deal, "expectedTerm");
    this.deleteIfFalsy(deal, "expectedLoanAmount");
    this.deleteIfFalsy(deal, "ltv");
    this.deleteIfFalsy(deal, "targetedClosing");
    this.deleteIfFalsy(deal, "collateralization");
    this.deleteIfFalsy(deal, "teamMember");
    this.deleteIfFalsy(deal, "capRate");
    this.deleteIfFalsy(deal, "projectTypeId");
    this.deleteIfFalsy(deal, "projectedRate");
    this.deleteIfFalsy(deal, "debtPerUnit");
    this.deleteIfFalsy(deal, "stageId");
    this.deleteIfFalsy(deal, "fundOwnership");
    this.deleteIfFalsy(deal, "borrower");
    this.deleteIfFalsy(deal, "dealStatusId");
    this.deleteIfFalsy(deal, "brokerCompanyId");
    this.deleteIfFalsy(deal, "brokerContactId");
    this.deleteIfFalsy(deal, "teamMemberId");
    this.deleteIfFalsy(deal, "desiredLoanAmount");
    this.deleteIfFalsy(deal, "cashEquity");
    this.deleteIfFalsy(deal, "assetManagerId");
    this.deleteIfFalsy(deal, "dealStatusChangeDate");
    this.deleteIfFalsy(deal, "version");
    this.deleteIfFalsy(deal, "dealMetricVersion");
    this.deleteIfFalsy(deal, "exitDebtYield");
    this.deleteIfFalsy(deal, "footnotesForPdfExport");
    this.deleteIfFalsy(deal, "pricingGuidance");
    this.deleteIfFalsy(deal, "estDevelopmentCost");
    return deal;
  };

  deleteIfFalsy(deal, fieldName) {
    if (!deal[fieldName] && deal[fieldName] !== 0) deal[fieldName] = null;
  }

  redirectToDetails = () => {
    const { history } = this.props;
    const { dealId, sectionName } = this.props.match.params;
    if (dealId) {
      history.replace(`/deal/${dealId}`);
    }
  };


  validateDeal = (deal) => {
    let isValid = true;
    let hasPrimary = false;
    let hasMultiplePrimary = false;
    deal.funds.forEach(fund => {
      if (fund.fundDealBridge.isPrimary && !hasPrimary)
        hasPrimary = true;
      else if (fund.fundDealBridge.isPrimary && hasPrimary)
        hasMultiplePrimary = true;
    });

    if (!hasPrimary) {
      ToastError("Please select a primary Group");
      isValid = false;
    } else if (hasMultiplePrimary) {
      ToastError("Please select only one primary Group");
      isValid = false;
    }
    return isValid;
  };

  onSubmit = deal => {
    const { dealId } = this.props.match.params;
    if (this.validateDeal(deal)) {
      ToastInfo("Saving, please wait")
      const clonedValues = cloneDeep(deal);
      const updatedDeal = this.deleteFalsyValues(clonedValues);
      const dealToSave = modifyValuesForSerialization(updatedDeal);

      this.props.updateDeal({
        deal: dealToSave, id: dealToSave.id,
        callback: () => { this.setState({ isSaving: false }) }
      });
    }
  };

  startSave = () => {
    this.setState({ isSaving: true });
  };

  startCancel = () => {
    this.setState({ isCanceling: true });
  };

  finishSave = () => {
    this.setState({ isSaving: false, isCanceling: false });
  };

  renderBody = () => {
    const { sectionName } = this.props.match.params;
    const { deal,authentication } = this.props;

    if (!deal) return null;

    deal.authentication = authentication;
    
    let sectionRows = null;
    let configItems = {
      companyFunds: sortBy(deal.ancillary.companyFunds, "name"),
      collaborationGroup: sortBy(deal.ancillary.colaborationGroups, "name"),
      projectTypes: sortBy(deal.ancillary.projectTypes, "name"),
      rateTypes: sortBy(deal.ancillary.rateTypes, "name"),
      fixedIndexes: sortBy(deal.ancillary.fixedIndexes, "name"),
      floatingIndexes: sortBy(deal.ancillary.floatingIndexes, "name"),
      loanTypes: sortBy(deal.ancillary.loanTypes, "name"),
      loanProceedAssumptions: deal.ancillary.loanProceedAssumptions,
      sponsorCompanies: sortBy(deal.ancillary.sponsorCompanies, "name"),
    };
    switch (sectionName) {
      case DEAL_SECTION_KEYS.GENERAL_INFORMATION:
        sectionRows = generalInfoRows;
        break;
      case DEAL_SECTION_KEYS.DISPOSITION_SETTINGS:
        sectionRows = dealDisposition;
        break;
      case DEAL_SECTION_KEYS.UNDERWRITING_ASSUMPTIONS:
        sectionRows = dealDisposition;
        break;
      case DEAL_SECTION_KEYS.CASHFLOW_ASSUMPTIONS:
        sectionRows = generateCashflowEdit(deal);
        break;
      case DEAL_SECTION_KEYS.ORGANIZATION:
        sectionRows = dealOrganization;
        break;
    }

    if (!sectionRows)
      return null;

    return (<AccordionEditSection
      rows={sectionRows}
      configItems={configItems}
      finishSave={this.finishSave}
      isSaving={this.state.isSaving}
      isCanceling={this.state.isCanceling}
      data={deal}
      onSubmit={this.onSubmit}
      onCancel={this.finishSave} />);
  }

  render() {
    const { sectionName } = this.props.match.params;
    const { deal } = this.props;
    if (!deal) return null;
    if (sectionName === DEAL_SECTION_KEYS.INTEGRATIONS) {
      return <EditDealIntegrations {...this.props} />;
    }
    return (
      <>
        <CardPageLayout
          {...this.props}
          isReversed
          bannerImageUrl={this.props.deal && this.props.deal.imageLarge}
          cardComponent={
            <GenericHeroCard
              save={this.startSave}
              cancel={this.startCancel}
              {...{ ...this.props, buttons: this.state.dealHeroCardButtons, deal: deal, title: deal.name, backLabel: "Deal Details" }}
            />
          }
          bodyComponent={<div className="d-flex f-1 flex-column">{this.renderBody()}</div>}
        />
      </>
    );
  }
}

const mapStateToProps = ({ dealSettings, authentication, enumeratedTypes, }) => ({
  ...dealSettings
  , enumeratedTypes: { ...enumeratedTypes }
  , company: mapCompanySelector(authentication)
  , authentication

});

export default compose(
  withRouter
  , connect(mapStateToProps, {
    dealGet
    , updateDeal
  })
)(DealEdit);
